export default __webpack_public_path__ + "static/SRUS OC114 - Especification Del Producto y Datos Técnicos-57fc26ac0dd2d9213148a01cdbfb4b18.pdf";